import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ROUTE_LINK_LOCATION, Selected_Index } from '../../../../constants/external-constants';
import ButtonIcon from '../../../button';
import { ListTabButton } from '../../../common/list-tab/list-tab-button.component';
import { DisputeForm } from '../dispute/dispute-form/index';
import { disputeDetailActions } from '../../../../store/external/invoice/dispute/dispute-details.reducer';
import DisputeComment from '../dispute/dispute-comment/dispute-comment.component';
import DisputeHistory from '../dispute/dispute-history/dispute-history.component'
import { validateAccessModule } from '../../../../utils/helpers.utils';
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../utils/rbac-constants.utils';

class DisputeDetailsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Comments",
                    "hidden": false,
                    "disable": true
                },
                {
                    "id": Selected_Index.i_Two,
                    "label": "History",
                    "hidden": false,
                    "disable": true
                }
            ],
        };
    }

    FilterIndex = (tabIndex) => {
        this.setState({ selectedIndex: tabIndex });
        this.renderTabContent(tabIndex)
    }

    handlecloseForm = () => {
        
        const { handleClose, resetDisputeDetailsForm,pageRedirection } = this.props;
        if(pageRedirection) {
            this.props.history.push(`${ROUTE_LINK_LOCATION.invoiceDisputeLink}`);
        }
        resetDisputeDetailsForm();
        handleClose();
    }

    renderTabContent = (index) => {
        this.setState({ selectedTab: index });
    }

    activeListTab = (listTab) => {
        const { disputeDetailsId, invoiceDisputeDetailsForm } = this.props;

        return listTab.map(item => {
            var disabled = item.disable;
            if (((item.id === Selected_Index.i_One || item.id === Selected_Index.i_Two) && disputeDetailsId > 0) || (invoiceDisputeDetailsForm && invoiceDisputeDetailsForm.id > 0)) {
                disabled = false;
            }

            return {
                ...item,
                disable: disabled
            };
        })
    }

    render() {
        const { disputeDetailsId, invoiceDisputeDetailsForm } = this.props;
        const { listTab, selectedIndex } = this.state;
    
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceDisputeDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceDisputeDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceDisputeDashboardRW])
        let disputeId = disputeDetailsId > 0  ? disputeDetailsId : invoiceDisputeDetailsForm && invoiceDisputeDetailsForm.id > 0 ? invoiceDisputeDetailsForm.id :  disputeDetailsId;
        const roles = {
            isReadOnly,
            isReadAndWrite,
            isReadAndExtractOnly
        }
        return (
            <div className="layout-container">
                <ButtonIcon onClick={this.handlecloseForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" />
                {listTab ? <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.FilterIndex} />
                    : null}
                <div className={`${this?.props?.isMultiContainer ? "" : "details-container"} date-picker-main-container`}>
                    {(this.state.selectedIndex === Selected_Index.i_Zero || this.props.selected) &&
                        <DisputeForm disputeDetailsId={disputeId} roles={roles} />}

                    {this.state.selectedIndex === Selected_Index.i_One &&
                        <DisputeComment disputeDetailsId={disputeId} roles={roles}/>}

                    {this.state.selectedIndex === Selected_Index.i_Two &&
                        <DisputeHistory disputeDetailsId={disputeId} hideCustomColumn={true} roles={roles}/>}

                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        const { invoiceDisputeDetails } = state;
        const { invoiceDisputeDetailsForm } = state.form;

        return {
            invoiceDisputeDetails,
            invoiceDisputeDetailsForm
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, disputeDetailActions),
        dispatch
    )
)(DisputeDetailsView)